<template>
  <div class="hello TdownloadRisk">
    <div ref="topheight">
      <div class="download_banner1">
        <li style="overflow: hidden"></li>
        <div class="download_title">
          <h4 style="margin-right: 0">
            <img
              style="height: 64px; weight: 64px"
              src="./img/risk.png"
              alt=""
            />杰宜斯云风控
          </h4>
          <div style="display: flex; width: 810px; margin: 0 auto">
            <img
              v-show="!show1"
              @mouseover="mouseover_img1"
              class="btn_img"
              src="../../assets/images/Android.png"
              alt=""
            />
            <img
              @click.stop.prevent="code_show = true"
              @click="getQRCode()"
              @mouseout="mouseout_img1"
              v-show="show1"
              class="btn_img"
              src="../../assets/images/Android1.png"
              alt=""
            />
            <img
              v-show="!show2"
              @mouseover="mouseover_img2"
              class="btn_img"
              src="../../assets/images/iosButton.png"
              alt=""
            />
            <img
              @click.stop.prevent="code_show1 = true"
              @click="getIOCode()"
              @mouseout="mouseout_img2"
              v-show="show2"
              class="btn_img"
              src="../../assets/images/iosButton1.png"
              alt=""
            />
            <img
              v-show="!show3"
              @mouseover="mouseover_img3"
              class="btn_img"
              src="../../assets/images/userManual.png"
              alt=""
            />
            <img
              @click="getSYCode()"
              @mouseout="mouseout_img3"
              v-show="show3"
              class="btn_img"
              src="../../assets/images/userManual1.png"
              alt=""
            />
            <!-- <a href="/api/upload/JeesMTCAutoUpdate/JeesMTCSetup.exe"
            ><img
              v-show="!show"
              @mouseover="mouseover_img"
              class="btn_img"
              src="../../assets/images/btn01.png"
              alt=""/>
            <img
              @mouseout="mouseout_img"
              v-show="show"
              class="btn_img"
              src="../../assets/images/btn02.png"
              alt=""
          /></a> -->
          </div>
        </div>
        <div class="img_box1">
          <img class="pcImg_l" src="./img/android.png" alt="" />
          <img class="pcImg_r1" src="./img/ios.png" alt="" />
        </div>
      </div>
    </div>
    <div
      style="min-height: 330px; background-color: #F3F5F6"
      :style="{ height: bottomHeight+'px' }"
    >
    
    </div>
    <nnav></nnav>
    <div style="position: relative; margin-top: 195px">
      <foot></foot>
    </div>
    <transition name="el-fade-in-linear">
      <div
        class="wxCode"
        v-show="code_show"
        @click.stop.prevent="code_show = false"
      >
        <div
          class="wxBox"
          style="
            background-color: #fff;
            width: 400px;
            padding-top: 1px;
            text-align: center;
          "
          @click.stop.prevent="stop"
        >
          <h2 style="color: #000; margin-top: 20px">Android</h2>
          <div class="code"><canvas id="QRCode" /></div>
          <h3 style="margin-top: 30px; font-size: 18px">
            请使用安卓手机浏览器
          </h3>
          <h3 style="font-size: 18px">扫描图片二维码下载安装</h3>
        </div>
      </div>
    </transition>
    <transition name="el-fade-in-linear">
      <div
        class="wxCode"
        v-show="code_show1"
        @click.stop.prevent="code_show1 = false"
      >
        <div
          class="wxBox"
          style="
            background-color: #fff;
            width: 400px;
            padding-top: 1px;
            text-align: center;
          "
          @click.stop.prevent="stop"
        >
          <h2 style="color: #000; margin-top: 20px">IOS</h2>
          <!-- <div style="margin-top:20px">
            <el-link type="primary" href="https://webtrader.jeesit.com/#/login"
              >https://webtrader.jeesit.com/#/login</el-link
            >
          </div> -->
          <div class="code"><canvas id="IOCode" /></div>
          <!-- <el-button style="margin-top:20px" type="primary" @click="fz()"
            >复制</el-button
          >
          <h3 style="margin-top: 30px;font-size: 14px;">
            使用手机浏览器打开以上网址
          </h3>
          <h3 style="font-size: 14px;">即可登录操作</h3> -->
          <h3 style="margin-top: 30px; font-size: 18px">请使用手机相机</h3>
          <h3 style="font-size: 18px">扫描图片二维码下载</h3>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import foot from "../../components/footer/index";
import nnav from "../../components/nav/index";
import "./style.css";
import QRCode from "qrcode";
export default {
  components: { foot, nnav },
  name: "TdownloadRisk",
  data() {
    return {
      bottomHeight: 0,
      code_show: false,
      code_show1: false,
      QRCodeMsg: "", // 生成二维码信息
      IOCodeMsg: "",
      appUrl: "",
      MHeight: document.documentElement.clientHeight - 50 + "px",
      show: false,
      show1: false,
      show2: false,
      show3: false,

      width_: "1200px",
      screenWidth: document.body.clientWidth,
      backgroundImage1:
        "url(" + require("@/assets/images/bg/page4.png") + ") no-repeat center",
      backgroundImage2:
        "url(" + require("@/assets/images/bg/page5.png") + ") no-repeat center",
      backgroundImage3:
        "url(" + require("@/assets/images/bg/page6.png") + ") no-repeat center",
    };
  },
  mounted() {
    this.screenWidth = document.body.clientWidth;

    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };

    this.$axios.post("/app/get_new").then((res) => {
      // console.log(res);
      this.tokenInvalid(res);
      if (res.data.code == 200) {
        this.appUrl = res.data.data.filePath;
      }
    });

    this.getHeight();
  },
  methods: {
    getHeight() {
      let height =
        document.body.clientHeight - this.$refs.topheight.clientHeight - 280;
      this.bottomHeight = height;
    },
    mouseover_img() {
      this.show = true;
    },
    mouseout_img() {
      this.show = false;
    },
    mouseover_img1() {
      this.show1 = true;
    },
    mouseout_img1() {
      this.show1 = false;
    },
    mouseover_img2() {
      this.show2 = true;
    },
    mouseout_img2() {
      this.show2 = false;
    },
    mouseover_img3() {
      this.show3 = true;
    },
    mouseout_img3() {
      this.show3 = false;
    },
    getQRCode() {
      this.QRCodeMsg = "http://39.101.174.218:8081/apk/risk.apk"; // 生成的二维码为URL地址
    },
    getIOCode() {
      // this.IOCodeMsg = "https://webtrader.jeesit.com/";
      this.IOCodeMsg =
        "https://apps.apple.com/cn/app/%E6%9D%B0%E5%AE%9C%E6%96%AF%E4%BA%91%E9%A3%8E%E6%8E%A7/id6450696802";
    },
    getSYCode() {
      // window.location.href = '/index/help/faq?type=6';
      // window.open("https://yuntest.jeesit.com/index/help/faq?type=6")
      window.open(window.location.origin + "/index/help/faq?type=7");
    },
    fz() {
      var input = document.createElement("input"); // 创建input对象
      input.value = "https://webtrader.jeesit.com/#/login"; // 设置复制内容

      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      this.$message.success("复制成功！");
    },
  },
  watch: {
    screenWidth() {
      // console.log(this.screenWidth);
      if (this.screenWidth < 1039 && this.screenWidth > 768) {
        this.width_ = "750px";
      }
      if (this.screenWidth > 1040 && this.screenWidth < 1180) {
        this.width_ = "1040px";
      }
      if (this.screenWidth > 1180) {
        this.width_ = "1200px";
      }
      if (this.screenWidth < 750) {
        this.width_ = "980px";
      }
    },
    QRCodeMsg(val) {
      // 获取页面的canvas
      var msg = document.getElementById("QRCode");
      // 将获取到的数据（val）画到msg（canvas）上
      QRCode.toCanvas(msg, val, function (error) {
        // console.log(error);
      });
    },

    IOCodeMsg(val) {
      // 获取页面的canvas
      var msg = document.getElementById("IOCode");
      // 将获取到的数据（val）画到msg（canvas）上
      QRCode.toCanvas(msg, val, function (error) {
        // console.log(error);
      });
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/view/TdownloadRisk/index.vue